import React, { Component } from 'react'

import { API_BASE_URL_DEV, API_BASE_URL_PROD } from './../config.js'
import arrowBack from './../css/Pfeil_Daniela.svg'

export default class MenuDiary extends Component {
  render() {
    return (
      <div id="menu--diary" className="menu menu--diary">
        <MenuEntry {...this.props} />
      </div>
    )
  }
}

class MenuEntry extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hidden: true,
      subEntries: [],
      menuEntry: {
        title: 'Tags',
        category: 'tags'
      }
    }
  }

  componentDidMount() {
    const url =
      (process.env.NODE_ENV === 'development'
        ? API_BASE_URL_DEV
        : API_BASE_URL_PROD) + 'posts/tags'

    fetch(url, {})
      .then(response => response.json())
      .then(json => {
        const tags = [{ Slug: 'alle', Title: 'Alle' }]
        json.forEach(tag => {
          if (tag.length > 0) {
            tags.push({ Slug: tag.toLowerCase(), Title: tag })
          }
        })
        this.setState({ subEntries: tags })
      })
  }

  toggle() {
    if (this.state.subEntries.length !== 0) {
      this.setState({ hidden: !this.state.hidden })
    } else {
      console.log('hidden', this.state.hidden)
      this.setState({ hidden: !this.state.hidden })
      window.history.pushState(null, null, '/' + this.props.menuEntry.category)
      window.dispatchEvent(new window.PopStateEvent('popstate'))
    }
  }

  goHome() {
    window.history.pushState(null, null, '/')
    window.dispatchEvent(new window.PopStateEvent('popstate'))
  }

  render() {
    return (
      <div className="menu-entry menu-entry--diary">
        <a
          className="menu-entry-main menu-entry-main--diary menu-entry-main--back"
          onClick={this.goHome.bind(this)}
        >
          {'<--'}
        </a>
        <a
          className="menu-entry-main menu-entry-main--diary menu-entry-main--arrow"
          onClick={this.goHome.bind(this)}
        >
          <img src={arrowBack} alt="Zurück" />
        </a>
        <a
          className="menu-entry-main menu-entry-main--diary menu-entry-main--burger"
          onClick={this.toggle.bind(this)}
        >
          #
        </a>
        {this.state.subEntries.map(function(subEntry, index) {
          return (
            <a
              className={
                'menu-entry-sub menu-entry-sub--diary menu-entry-sub--' +
                subEntry.Slug +
                (this.state.hidden ? ' menu-entry-sub--hidden' : '') +
                (this.props.slug === subEntry.Slug ||
                this.props.category === subEntry.Slug
                  ? ' menu-entry-sub--selected'
                  : '')
              }
              key={index}
              href={'#' + subEntry.Slug}
              onClick={this.toggle.bind(this)}
            >
              {'#' + subEntry.Title}
            </a>
          )
        }, this)}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/front/components/menudiary.js